module.exports = __webpack_public_path__ + "img/1.e2843761.png";